import styled from 'styled-components'
import { Badge } from 'antd'

export const ChatItemContainer = styled.div`
    display: flex;
    width: 100%;
    background: #fff;
    align-items: center;
    margin-bottom: 3px;

    &:hover {
        background: #eee;
        cursor: pointer;
    }
`

export const AvatarContainer = styled.div`
    height: 100%;
    padding: 10px;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ccc;
    background-image: url(${props => props.url});
    background-size: cover;
`

export const Avatar = styled.img`
`

export const ChatItemDetails = styled.div`
    display: flex;
    height: 100%;
    width: calc(100% - 40px);
    padding: 10px;
    justify-content: space-between;
`

export const CategoryPatientContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

export const Category = styled.p`
    font-size: 12px;
    color: #999;
    line-height: 12px;
    margin-bottom: 5px;
    font-weight: 600;
    color: #7bad7e;
`

export const Patient = styled.p`
    font-size: 14px;
    color: #999;
    line-height: 12px;
    margin-bottom: 0;
    font-weight: 400;
`

export const ChatLastEventTime = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    font-size: 12px;
    align-items: flex-end;
    text-align: right;
`

export const NoCountPlaceholder = styled.div`
    height: 25px;
`